import cn from "classnames";
import { useFormikContext } from "formik";

import { checkTabHasErrors } from "./FormTabs.helpers";

import { Typography } from "shared/ui/components/Typography";

import { FormTabProps, FormTabsProps } from "./FormTabs.types";

import { CALCULATOR_TYPES } from "constants/calculator";

import styles from "./FormTabs.module.scss";

const FormTab = ({
  tab,
  activeTab,
  onActiveTabChange
}: FormTabProps) => {
  const { errors, touched } = useFormikContext<any>();
  const hasErrors = tab.fieldList
    ? checkTabHasErrors(tab.fieldList, errors, touched)
    : false;

  return (
    <div
      className={cn(styles.tab, {
        [styles.activeTab]: activeTab === tab.value,
      })}
      onClick={() => onActiveTabChange(tab.value)}
    >
      <Typography variant="bodyM">{tab.label}</Typography>

      {hasErrors &&
        <span className={styles.errorLabel}>
          !
        </span>
      }
    </div>
  )
}


const FormTabs = ({
  tabsConfig,
  activeTab,
  calculatorType,
  onActiveTabChange,
}: FormTabsProps) => {
  return (
    <div className={cn(styles.root, {
      [styles.rootModal]: calculatorType === CALCULATOR_TYPES.LIMITED_PRO,
    })}>
      {tabsConfig.map((tab) => (
        <FormTab key={tab.value} tab={tab} activeTab={activeTab} onActiveTabChange={onActiveTabChange} />
      ))}
    </div>
  );
};

export default FormTabs;
